import React from 'react';
import {observer} from 'mobx-react-lite';
import {Approval} from '../../../Core/mobx/ParameterStore/Approval';
import {CategoryCard} from '../CategoryCard';
import {Parameter} from '../../../Core/mobx/ParameterStore/ParameterStore';
import {DatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {Grid} from '@material-ui/core';
import {SwitchCustom, TextBox} from '../../../Core/UI';

type LicenseProps = {
    parameters: Approval;
    valueChanged: (p?: Parameter, value?: any) => void;
    setCategory: (entry: string) => void;
    index: number;
};

const License = observer(({parameters, valueChanged, setCategory, index}: LicenseProps) => {
    return (
        <CategoryCard title={'License'} setCategory={setCategory} index={index}>
            <Grid item xs={4}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <DatePicker
                        inputVariant="outlined"
                        variant="inline"
                        openTo="year"
                        views={['year', 'month']}
                        label={'When did your license get suspended?'}
                        style={{width: '100%', marginTop: 8}}
                        value={parameters.suspendedLicenseDate?.value || null}
                        onChange={(date) => valueChanged(parameters.suspendedLicenseDate, date)}
                    />
                </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={4}>
                <SwitchCustom
                    param={{
                        name: 'suspendedLicense',
                        label: 'Is your license still suspended?',
                        ...parameters.suspendedLicense,
                    }}
                    required={''}
                    valueChanged={valueChanged}
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id="licenseNotes"
                    label="Notes"
                    value={parameters.licenseNotes?.value}
                    onChange={(value) => valueChanged(parameters.licenseNotes, value)}
                />
            </Grid>
        </CategoryCard>
    );
});

export default License;
